/* eslint-disable react/no-danger */
import Head from 'next/head';
import React from 'react';

const IndexPage = () => (
  <Head>
    <link key="preconnect-cdn" rel="preconnect" href="https://cdn.boatinternational.com" />

    <link key="preconnect-api" rel="preconnect" href={process.env.BLAZE_GRAPHQL_URI} />
    <link
      key="preconnect-gf"
      rel="preconnect"
      href="https://fonts.gstatic.com"
      crossOrigin="anonymous"
    />
    <link
      key="preload-font1"
      rel="preload"
      href="/static/fonts/euclid.woff"
      as="font"
      crossOrigin="anonymous"
      type="font/woff"
    />
    <link
      key="preload-font2"
      rel="preload"
      href="/static/fonts/apercu-regular.woff2"
      as="font"
      crossOrigin="anonymous"
      type="font/woff2"
    />
    <link
      key="preload-font3"
      rel="preload"
      href="/static/fonts/RomainText.woff2"
      as="font"
      crossOrigin="anonymous"
      type="font/woff2"
    />
    {/* <link
        rel="preload"
        href="/static/fonts/RomainHeadline-Bold.woff2"
        as="font"
        crossOrigin="anonymous"
        type="font/woff2"
      /> */}
    <link
      key="preload-font4"
      rel="preload"
      href="/static/fonts/RomainHeadline.woff2"
      as="font"
      crossOrigin="anonymous"
      type="font/woff2"
    />
    <link
      key="preload-mi"
      rel="preload"
      as="style"
      href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap"
    />
    <link
      key="preload-fa"
      rel="preload"
      as="style"
      href="https://use.fontawesome.com/releases/v5.7.1/css/all.css"
    />

    <meta key="apple-itunes-app" name="apple-itunes-app" content="app-id=409120727" />

    {/* Transcend Cookie Consent - TCF Stub and AirGap scripts must load before GTM */}
    <script
      key="transcend-tcf-stub"
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `"use strict";function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(){self.airgap?.ready||(self.airgap={readyQueue:[],ready(e){this.readyQueue.push(e)},...self.airgap});const e=()=>{const e="__tcfapiLocator",t=[],a=window;let n,s,o=a;for(;o;){try{if(o.frames[e]){n=o;break}}catch(e){}if(o===a.top)break;o=o.parent}n||(!function t(){const n=a.document,s=!!a.frames[e];if(!s)if(n.body){const t=n.createElement("iframe");t.style.cssText="display:none",t.name=e,n.body.appendChild(t)}else setTimeout(t,5);return!s}(),a.__tcfapi=function(...e){if(!e.length)return t;"setGdprApplies"===e[0]?e.length>3&&2===parseInt(e[1],10)&&"boolean"==typeof e[3]&&(s=e[3],"function"==typeof e[2]&&e[2]("set",!0)):"ping"===e[0]?"function"==typeof e[2]&&e[2]({gdprApplies:s,cmpLoaded:!1,cmpStatus:"stub"}):t.push(e)},a.addEventListener("message",(function(e){const t="string"==typeof e.data;let a={};if(t)try{a=JSON.parse(e.data)}catch(e){}else a=e.data;const n="object"==typeof a&&null!==a?a.__tcfapiCall:null;n&&window.__tcfapi(n.command,n.version,(function(a,s){let o={__tcfapiReturn:{returnValue:a,success:s,callId:n.callId}};e&&e.source&&e.source.postMessage&&e.source.postMessage(t?JSON.stringify(o):o,"*")}),n.parameter)}),!1))};airgap.ready((t=>{"TCF_EU"===t.loadOptions.consentManagerConfig.initialViewStateByPrivacyRegime[t.getRegimes()[0]]&&("undefined"!=typeof module?module.exports=e:e())}))}();`
      }}
    />

    {process.env.BUILD_LOAD_TRANSCEND_AIRGAP === 'true' && (
      <>
        {/*
      Advanced Consent Mode override: allow-list Google Ads/Analytics (GcmAdvanced)
      so non-personalized ads can serve before a consent decision. MUST run before
      the airgap script so the override is registered before airgap initialises.
    */}
        <script
          key="transcend-gcm-advanced-override"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `self.airgap = { overrides: [], cookieOverrides: [], ...self.airgap };
var allowGcmAdvanced = function(event) { if (event.purposes.has('GcmAdvanced')) event.allow(); };
self.airgap.overrides.push({ override: allowGcmAdvanced });
self.airgap.cookieOverrides.push(allowGcmAdvanced);`
          }}
        />

        <script
          key="transcend-airgap"
          data-cfasync="false"
          data-local-sync="allow-network-observable"
          data-prompt="1"
          data-report-only="off"
          data-dismissed-view-state="Collapsed"
          data-tcf-ui-dismissed-view-state="Collapsed"
          src={
            process.env.BUILD_PUBLIC_TRANSCEND_AIRGAP_ENV === 'prod'
              ? 'https://transcend-cdn.com/cm/ef49a3f1-d8c1-47d6-88fc-50e41130631f/airgap.js'
              : 'https://transcend-cdn.com/cm-test/ef49a3f1-d8c1-47d6-88fc-50e41130631f/airgap.js'
          }
        />
      </>
    )}

    <script
      key="gmt-script"
      dangerouslySetInnerHTML={{
        __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${process.env.GTM_ID}');
          `
      }}
    />

    <script
      key="custom-event-listeners"
      dangerouslySetInnerHTML={{
        __html: `
                      console.log('Blaze CMS Next.js Tools - IndexPage component loaded');
            document.addEventListener('click', function(e) {
              var toggleExpandedFilterDesktop = function(originalTarget) {
                var target = originalTarget.closest('.range-slider__wrapper, .filter__section');
                var wasOpen = target.classList.contains('open');

                var toClose = document.querySelectorAll('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open .filter__more-filters-desktop-content > .open');
                for (var i = 0; i < toClose.length; i++) {
                  toClose[i].classList.remove('open');
                }

                if (!wasOpen) target.classList.add('open');
              };

              var toggleExpandedFilterMobile = function(originalTarget) {
                var target = originalTarget.closest('.range-slider__wrapper, .filter__section');
                var wasOpen = target.classList.contains('open');

                var toCloseDesktop = document.querySelectorAll('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-desktop-content > .open');
                for (var i = 0; i < toCloseDesktop.length; i++) {
                  toCloseDesktop[i].classList.remove('open');
                }

                var toCloseMobile = document.querySelectorAll('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .open');
                for (var i = 0; i < toCloseMobile.length; i++) {
                  toCloseMobile[i].classList.remove('open');
                }

                if (!wasOpen) target.classList.add('open');
              };

              if (window.artificialClick) {
                window.artificialClick = false;
                return;
              }

              var foundSearchBarTextInput = false;
              var foundSearchBarLength = false;
              var foundSearchBarPriceYfs = false;
              var foundSearchBarPriceYfc = false;
              var foundSearchBarYearOfBuildYfs = false;
              var foundSearchBarDestinationsYfc = false;
              var foundMoreFiltersDesktop = false;
              var foundMoreFiltersMobile = false;
              var foundSearchBarYearOfBuildSyd = false;
              var foundSearchBarBuildersSyd = false;
              var foundSearchBarTopSpeedSyd = false;

              var target;

              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open')) {
                  foundMoreFiltersDesktop = true;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-desktop-toggler')) {
                  foundMoreFiltersDesktop = true;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open')) {
                  foundMoreFiltersMobile = true;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-toggler')) {
                  foundMoreFiltersMobile = true;
                }
              }

              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.bi-search-bar .filter__more-filters-desktop-toggler.filter__more-filters-desktop-toggler--open')) {
                  var scrollToTargetTogglerDesktop = document.querySelectorAll('.bi-directory')[0];

                  if (scrollToTargetTogglerDesktop) {
                    window.scrollTo(0, scrollToTargetTogglerDesktop.offsetTop - 100);
                    break;
                  }
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-toggler.filter__more-filters-mobile-toggler--open')) {
                  var scrollToTargetTogglerMobile = document.querySelectorAll('.bi-directory')[0];

                  if (scrollToTargetTogglerMobile) {
                    window.scrollTo(0, scrollToTargetTogglerMobile.offsetTop);
                    break;
                  }
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-content > .filter__section:first-child .form-field--checkbox')) {
                  foundSearchBarTextInput = true;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(2) .values')) {
                  foundSearchBarLength = true;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(2) .range__filter')) {
                  foundSearchBarLength = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .values')) {
                  foundSearchBarPriceYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .range__filter')) {
                  foundSearchBarPriceYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper:not(.filter__more-filters-mobile-wrapper--open) .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .form-field--select')) {
                  foundSearchBarPriceYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .form-field--select')) {
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .values')) {
                  foundSearchBarPriceYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .range__filter')) {
                  foundSearchBarPriceYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper:not(.filter__more-filters-mobile-wrapper--open) .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .form-field--select')) {
                  foundSearchBarPriceYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .form-field--select')) {
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .values')) {
                  foundSearchBarYearOfBuildSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) .range__filter')) {
                  foundSearchBarYearOfBuildSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4) .values')) {
                  foundSearchBarTopSpeedSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4) .range__filter')) {
                  foundSearchBarTopSpeedSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4) .values')) {
                  foundSearchBarYearOfBuildYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4) .range__filter')) {
                  foundSearchBarYearOfBuildYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .filter__section:nth-child(4) .form-field--select')) {
                  foundSearchBarDestinationsYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .filter__section:nth-child(4) .form-field--select')) {
                  foundSearchBarBuildersSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-content > .filter__section:first-child')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarTextInput = true;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(2)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarLength = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarPriceYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarPriceYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarYearOfBuildSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarTopSpeedSyd = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(4)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarYearOfBuildYfs = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .filter__section:nth-child(4)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarDestinationsYfc = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .filter__section:nth-child(4)')) {
                  target.classList.toggle('bi-search-bar__filter--open');
                  foundSearchBarBuildersSyd = true;
                  break;
                }

                if (target.matches('.bi-yacht-specs-full--togglable .heading--section')) {
                  target.parentNode.classList.toggle('bi-yacht-specs-full__open-section');
                  break;
                }

                if (target.matches('.contact__buttons--size-sidebar .contact-form__close')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.contact__buttons--size-sidebar')[0].classList.remove('contact__buttons--modals-open');
                  break;
                }

                if (target.matches('.contact__buttons--size-sidebar .contact__buttons__button--at')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.contact__buttons--size-sidebar')[0].classList.add('contact__buttons--modals-open');
                  document.querySelectorAll('.contact__buttons--size-small .contact__buttons__button--at')[0].click();
                  break;
                }

                if (target.matches('.contact__buttons--size-sidebar .contact__buttons__button--phone')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.contact__buttons--size-sidebar')[0].classList.add('contact__buttons--modals-open');
                  document.querySelectorAll('.contact__buttons--size-small .contact__buttons__button--phone')[0].click();
                  break;
                }

                if (target.matches('.contact__buttons--size-sidebar .contact__buttons__button--desktop')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.contact__buttons--size-sidebar')[0].classList.add('contact__buttons--modals-open');
                  document.querySelectorAll('.contact__buttons--size-small .contact__buttons__button--desktop')[0].click();
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-sidebar-new .ecommerce__buttons__button--message') && !target.matches('.charter-page .ecommerce__buttons--size-sidebar-new .ecommerce__buttons__button--message')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  window.tempButtonEl = document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--message-email_broker')[0];
                  window.tempButtonElId = window.tempButtonEl.getAttribute('id');
                  window.tempButtonEl.removeAttribute('id');
                  window.tempButtonEl.click();
                  window.tempButtonEl.setAttribute('id', window.tempButtonElId);
                  delete window.tempButtonEl;
                  delete window.tempButtonElId;
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-sidebar-new .ecommerce__buttons__button--phone') && !target.matches('.charter-page .ecommerce__buttons--size-sidebar-new .ecommerce__buttons__button--phone')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--phone')[0].click();
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-sidebar-new .ecommerce__buttons__button--desktop-multi')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--desktop')[0].classList.add('ecommerce__buttons__hidden-button--visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--desktop')[0].click();
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-contact-and-request-call .contact-form__close')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--desktop')[0].classList.remove('ecommerce__buttons__hidden-button--visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.remove('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-contact-and-request-call-mobile .ecommerce__buttons__button--message-email_broker')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--message-email_broker')[0].click();
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-contact-and-request-call-mobile .ecommerce__buttons__button--phone')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--phone')[0].click();
                  break;
                }

                if (target.matches('.ecommerce__buttons--size-contact-and-request-call-mobile .ecommerce__buttons__button--message-request_call_back')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call')[0].classList.add('ecommerce__buttons--size-contact-and-request-call--temporarily-visible');
                  document.querySelectorAll('.ecommerce__buttons--size-contact-and-request-call .ecommerce__buttons__button--message-request_call_back')[0].click();
                  break;
                }

                if (target.matches('.newsletter-signup__button--type-desktop-sidebar')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.newsletter-signup__button--type-desktop-body-modal')[0].click();
                  break;
                }

                if (target.matches('.bi-directory__sort-and-reset__reset')) {
                  window.artificialClick = true;
                  document.querySelectorAll('.bi-search-bar .filter__more-filters-desktop-buttons .filter__reset > div:last-child')[0].click();
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open .filter__more-filters-desktop-content > .filter__section--checkboxes > p')) {
                  toggleExpandedFilterDesktop(target.parentNode);
                  foundMoreFiltersDesktop = true;
                  break;
                }

                if (
                  target.matches('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open .filter__more-filters-desktop-content > .filter__section--selects label') ||
                  target.matches('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open .filter__more-filters-desktop-content > .range-slider__wrapper label')
                ) {
                  toggleExpandedFilterDesktop(target.parentNode.parentNode);
                  foundMoreFiltersDesktop = true;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__section--checkboxes > p')) {
                  toggleExpandedFilterMobile(target.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (
                  target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__section--selects label') ||
                  target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:not(:nth-child(3)) label') ||
                  target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__more-filters-desktop-content .range-slider__wrapper label')
                ) {
                  toggleExpandedFilterMobile(target.parentNode.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) label')) {
                  toggleExpandedFilterMobile(target.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (
                  target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__section--selects label') ||
                  target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:not(:nth-child(3)) label') ||
                  target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__more-filters-desktop-content .range-slider__wrapper label')
                ) {
                  toggleExpandedFilterMobile(target.parentNode.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (target.matches('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper:nth-child(3) label')) {
                  toggleExpandedFilterMobile(target.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }

                if (
                  target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__section--selects label') ||
                  target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .range-slider__wrapper label') ||
                  target.matches('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content .filter__more-filters-desktop-content .range-slider__wrapper label')
                ) {
                  toggleExpandedFilterMobile(target.parentNode.parentNode);
                  foundMoreFiltersMobile = true;
                  break;
                }
              }

              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.bi-search-bar .filter__more-filters-mobile-buttons > .button--full-width')) {
                  foundMoreFiltersMobile = false;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-desktop-buttons > .button--full-width')) {
                  foundMoreFiltersDesktop = false;
                  break;
                }
              }

              if (!foundSearchBarTextInput) {
                var toRemoveSearchBarTextInput = document.querySelector('.filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:first-child');
                if (toRemoveSearchBarTextInput) {
                  toRemoveSearchBarTextInput.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarLength) {
                var toRemoveSearchBarLength = document.querySelector('.filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(2)');
                if (toRemoveSearchBarLength) {
                  toRemoveSearchBarLength.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarPriceYfs) {
                var toRemoveSearchBarPriceYfs = document.querySelector('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarPriceYfs) {
                  toRemoveSearchBarPriceYfs.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarPriceYfc) {
                var toRemoveSearchBarPriceYfc = document.querySelector('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarPriceYfc) {
                  toRemoveSearchBarPriceYfc.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarYearOfBuildSyd) {
                var toRemoveSearchBarYearOfBuildSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarYearOfBuildSyd) {
                  toRemoveSearchBarYearOfBuildSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarTopSpeedSyd) {
                var toRemoveSearchBarTopSpeedSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarTopSpeedSyd) {
                  toRemoveSearchBarTopSpeedSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarYearOfBuildYfs) {
                var toRemoveSearchBarYearOfBuildYfs = document.querySelector('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarYearOfBuildYfs) {
                  toRemoveSearchBarYearOfBuildYfs.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarDestinationsYfc) {
                var toRemoveSearchBarDestinationsYfc = document.querySelector('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarDestinationsYfc) {
                  toRemoveSearchBarDestinationsYfc.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarBuildersSyd) {
                var toRemoveSearchBarBuildersSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarBuildersSyd) {
                  toRemoveSearchBarBuildersSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundMoreFiltersDesktop) {
                var toRemoveMoreFiltersDesktopToggler = document.querySelector('.bi-search-bar .filter__more-filters-desktop-toggler--open');
                if (toRemoveMoreFiltersDesktopToggler) {
                  window.artificialClick = true;
                  toRemoveMoreFiltersDesktopToggler.click();
                }
              }

              if (!foundMoreFiltersMobile) {
                var toRemoveMoreFiltersMobileToggler = document.querySelector('.bi-search-bar .filter__more-filters-mobile-toggler--open');
                if (toRemoveMoreFiltersMobileToggler) {
                  window.artificialClick = true;
                  toRemoveMoreFiltersMobileToggler.click();
                }
              }
            }, false);

            document.addEventListener('click', function(e) {
              const findFirstParent = function(el, selector) {
                while ((el = el.parentNode) && el !== document) {
                  if (el.matches(selector)) {
                    return el;
                  }
                }
              }

              const clickOnCloseModal = function(el) {
                var modalRoot = findFirstParent(target, '.modal');
                if (!modalRoot) return;

                var modalHeader = modalRoot.querySelectorAll('.modal__header')[0];
                if (!modalHeader) return;

                var modalClose = modalHeader.querySelectorAll('.modal__close')[0];
                if (!modalClose) return;

                modalClose.click();
              }

              var target;

              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.modal .boat-pro-form__content-wrapper .boat-pro-form__close-bar-wrapper')) {
                  clickOnCloseModal(target);
                  break;
                }
              }
            }, false);
          `
      }}
    />
  </Head>
);

export default IndexPage;
